<app-input-wrapper
  [label]="label"
  [required]="required"
  [errorMessage]="errorMessage"
  [touched]="touched"
>

<div class="image-upload-dropzone-container">
  <div
    class="image-upload-dropzone"
    [class.dragging]="isDragging"
    [class.disabled]="isAtMaxImages"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
  >
    <input
      type="file"
      accept="image/*"
      (change)="onFileChange($event)"
      class="file-input"
      [disabled]="isAtMaxImages"
    />
    <div class="dropzone-placeholder">
      <app-circle-icon
        icon="ri-upload-cloud-fill"
        [color]="'#41be8a'"
        [backgroundColor]="'#41be8a30'"
        [size]="40"
      ></app-circle-icon>

      <span
        >Drag & Drop or <a href="#" class="browse-files">Browse Files</a></span
      >
    </div>
  </div>

  <div class="image-preview-scroll">
    <div class="image-preview-wrapper" *ngFor="let img of images">
      <img [src]="img.url" class="preview-image" />
      <button *ngIf="deleteable" class="delete-btn" (click)="onDeleteClick(img, $event)">
        <i class="ri-close-line"></i>
      </button>
    </div>
  </div>
</div>
</app-input-wrapper>
